import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

/* PUBLIC */
import StartPage from "./Pages/StartPage";
import LoginPage from "./Pages/LoginPage";

/* PAGES */
import MenuPage from "./Pages/MenuPage";
import ContainerAcceptance from "./Pages/ContainerAcceptance";
import FulfilmentCenterAcceptance from "./Pages/FulfilmentCenterAcceptance";
import PutAway from "./Pages/PutAway";
import PrintLabels from "./Pages/PrintLabels";


import BinnedReport from "./Pages/BinnedReport";
import InventoryReport from "./Pages/InventoryReport";
import UnliftedPieces from "./Pages/UnliftedPieces";
import AcceptedReport from "./Pages/AcceptedReport";
import ASNAndSKUDetails from "./Pages/ASNAndSKUDetails";
import PickupReport from "./Pages/PickupReport";
import DispatchReport from "./Pages/DispatchReport";

import SupervisorAssignPage from "./Pages/SupervisorAssignPage";
import EmployeePickupPage from "./Pages/EmployeePickupPage";
import AdminUserManagement from "./Pages/AdminUserManagement";


/* LAYOUT */
import ProtectedLayout from "./layouts/ProtectedLayout";

export default function App() {
  //  Works for BOTH:
  // Local  -> "/"
  // IIS    -> "/frontend"
  const basename = process.env.REACT_APP_BASE_PATH || "/";

  return (
    <Router basename={basename}>
      <Routes>

        {/*  PUBLIC ROUTES (NO HEADER) */}
        <Route path="/" element={<StartPage />} />
        <Route path="/login" element={<LoginPage />} />

        {/*  PROTECTED ROUTES (WITH HEADER) */}
        <Route element={<ProtectedLayout />}>

          <Route path="/menu" element={<MenuPage />} />

          <Route
            path="/container-acceptance"
            element={<ContainerAcceptance />}
          />

          <Route
            path="/fulfilment-acceptance"
            element={<FulfilmentCenterAcceptance />}
          />
          <Route path="/putaway" element={<PutAway />} />
	  <Route path="/admin/users" element={<AdminUserManagement />} />

    
          <Route
            path="/print-labels"
            element={<PrintLabels />}
          />

          {/* REPORTS */}
          <Route path="/reports/binned" element={<BinnedReport />} />
          <Route path="/reports/inventory" element={<InventoryReport />} />
          <Route path="/reports/unlifted" element={<UnliftedPieces />} />
          <Route path="/reports/accepted" element={<AcceptedReport />} />
          <Route path="/reports/asn-sku" element={<ASNAndSKUDetails />} />
          <Route path="/reports/pickup" element={<PickupReport />} />
          <Route path="/reports/dispatch-report" element={<DispatchReport />} />

          {/* ASSIGNMENT */}
          <Route
            path="/supervisor-assign"
            element={<SupervisorAssignPage />}
          />
          <Route
            path="/employee-pickup"
            element={<EmployeePickupPage />}
          />

        </Route>

      </Routes>
    </Router>
  );
}
